/**
 * Bill Payments page configuration
 */
const billPaymentsConfig = {
  slug: 'bill-payments',
  category: 'Payments',
  title: 'Convenient Bill Payment Services',
  breadcrumb: 'Bill Payments',
  introduction:
    'The Uhamiaji SACCOS Bill Payment service enables members to conveniently pay a wide range of bills and service fees through a single platform. The service is designed to provide a secure, fast, and reliable payment experience, allowing members to settle various payments without visiting different service providers. Members can access the Bill Payment service at any time through the Uhamiaji SACCOS Member Portal or Mobile Application.',
  heroIcon: 'Receipt',
  heroCompact: true,
  heroShowIcon: false,
  heroShowActions: false,
  primaryAction: {
    label: 'Make a Payment',
    link: '/dashboard',
    icon: 'ArrowRight',
  },
  secondaryAction: {
    label: 'Contact Us',
    link: '/contact',
    icon: 'Phone',
  },
  meta: {
    title: 'Uhamiaji SACCOS | Bill Payments',
    description:
      'Pay SGR tickets, GePG, LUKU, water, TV, internet, airtime, education fees, insurance and more through Uhamiaji SACCOS.',
  },
  sections: [
    {
      type: 'grid',
      title: 'Available Bill Payment Services',
      intro:
        'Members can make payments for a variety of services offered by both government and private service providers. Supported services include Standard Gauge Railway (SGR) ticket payments, Government Electronic Payment Gateway (GePG) control numbers, prepaid electricity (LUKU), water utility bills, television subscriptions, internet services, airtime purchases, education fees, insurance premiums, and other approved service providers. Uhamiaji SACCOS continuously expands the list of supported billers to meet the evolving needs of its members.',
      items: [
        { icon: 'Train', title: 'SGR Tickets' },
        { icon: 'Building2', title: 'GePG Control Numbers' },
        { icon: 'Zap', title: 'Prepaid Electricity (LUKU)' },
        { icon: 'Droplets', title: 'Water Utility Bills' },
        { icon: 'Tv', title: 'Television Subscriptions' },
        { icon: 'Wifi', title: 'Internet Services' },
        { icon: 'Smartphone', title: 'Airtime Purchases' },
        { icon: 'GraduationCap', title: 'Education Fees' },
        { icon: 'ShieldCheck', title: 'Insurance Premiums' },
        { icon: 'Wallet', title: 'Other Approved Providers' },
      ],
    },
    {
      type: 'journey',
      title: 'How Bill Payment Works',
      items: [
        {
          number: '01',
          icon: 'MousePointerClick',
          title: 'Select Service',
          description: 'The member selects the desired service provider.',
        },
        {
          number: '02',
          icon: 'FileInput',
          title: 'Enter Reference',
          description:
            'The member enters the required customer reference number, account number, meter number, or Government Control Number depending on the selected service.',
        },
        {
          number: '03',
          icon: 'SearchCheck',
          title: 'Verify Bill',
          description: 'The system retrieves and displays the bill details for verification.',
        },
        {
          number: '04',
          icon: 'CheckCircle',
          title: 'Confirm Payment',
          description:
            'Once the details are verified, the member confirms the payment and receives a transaction confirmation.',
        },
      ],
    },
    {
      type: 'paymentOptions',
      title: 'Payment Options',
      intro: 'Choose a convenient and approved payment method for your bill payment.',
      options: [
        {
          icon: 'Wallet',
          heading: 'Available Savings Balance',
          content:
            'Members may pay bills using their available savings balance, where applicable, or through other payment methods supported by Uhamiaji SACCOS.',
        },
        {
          icon: 'CreditCard',
          heading: 'Other Supported Payment Methods',
          content:
            'Depending on the type of service and the applicable SACCOS policies, members may also utilize approved service loan facilities to complete eligible bill payments, in addition to other supported payment methods.',
        },
      ],
    },
    {
      type: 'twoColumnInfo',
      left: {
        title: 'Secure and Reliable Transactions',
        icon: 'Lock',
        items: [
          'All bill payment transactions are processed through secure payment channels.',
          'Members\' financial information is protected through secure transaction processing.',
          'Payment details are validated before a transaction is completed.',
          'Validation helps minimize errors and ensures payments are made to the correct service provider.',
          'Members can monitor the status of their transactions.',
          'Members can access their payment history whenever required.',
        ],
      },
      right: {
        title: 'Benefits of Bill Payment Services',
        icon: 'ShieldCheck',
        items: [
          { label: 'Convenient', text: 'Manage everyday financial obligations from a single platform.' },
          { label: 'Faster Processing', text: 'Reduce the time required to complete payments.' },
          { label: 'Secure Transactions', text: 'Make payments through secure payment channels.' },
          { label: 'Instant Confirmation', text: 'Receive confirmation after a successful payment.' },
          { label: 'Transaction History', text: 'Access and review previous payment transactions.' },
          { label: 'Easy Access', text: 'Access essential services quickly and securely.' },
        ],
      },
    },
  ],
  support: {
    enabled: true,
    title: 'Need Assistance?',
    content:
      'If you experience any challenges while making a payment or require assistance with a specific bill or service provider, please contact the Uhamiaji SACCOS Office. Our support team is available to provide guidance, resolve payment-related issues, and ensure that members receive efficient and reliable service at all times.',
    action: {
      label: 'Contact Uhamiaji SACCOS',
      link: '/contact',
      icon: 'Phone',
    },
  },
};

export default billPaymentsConfig;
